import React from "react";
import { useSearchParams } from "react-router-dom";
import CardContainer from "../../Components/CardsContainerForSale/CardsContainerForSale";
import FilterView from "../../Components/FilterView/FilterView";
import {
  getFiltersFromSearchParams,
  filtersToSearchParams,
} from "../../utils/propertyCatalogFilters";

const Sale = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filtersFromURL = getFiltersFromSearchParams(searchParams);
  const page = parseInt(searchParams.get("page"), 10) || 1;

  // Al aplicar filtros se reinicia la paginación a la página 1.
  const handleFilterChange = (filters) => {
    setSearchParams(filtersToSearchParams(filters, { page: 1 }));
  };

  return (
    <div>
      <FilterView onFilterChange={handleFilterChange} initialFilters={filtersFromURL} />
      <CardContainer filters={{ ...filtersFromURL, page }} />
    </div>
  );
};

export default Sale;
